import { Action } from '@/constants/constants';
import { Feature } from '@/constants/features';
import { Module } from '@/constants/modules';

export { useTriggersActionsStore } from './store';

export const triggersActionsRoutes = [
	{
		path: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}`,
		name: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}`,
		component: () => import('./components/TriggersActionsList'),
	},
	{
		path: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}/${Action.MODIFY}`,
		name: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}/${Action.MODIFY}`,
		component: () => import('./components/TriggersActionsModify'),
	},
	{
		path: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}/${Action.MODIFY}/:triggerId`,
		name: `/${Module.SETTINGS.name}/${Feature.TRIGGERS_ACTIONS}/${Action.MODIFY}/:triggerId`,
		component: () => import('./components/TriggersActionsModify'),
		props: true,
	},
];
